/* ══════════════════════════════════════════════════════════════════════
   WILL·Y and Sam — comportamiento del tema
   Menú lateral · barra al hacer scroll · visor de fotos · carrusel móvil
   · nombre del color al pasar el cursor · selector de talla
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* al entrar desde otra pantalla la página arranca arriba del todo */
  if ('scrollRestoration' in history) { history.scrollRestoration = 'manual'; }
  function toTop() {
    if (!location.hash) { window.scrollTo(0, 0); document.documentElement.scrollTop = 0; }
  }
  toTop();
  window.addEventListener('pageshow', toTop);

  /* ── barra superior ─────────────────────────────────────────────── */
  var top = document.getElementById('top');
  var heroNav = document.getElementById('heroNav');
  function sync() {
    var on = window.scrollY > 4;
    if (top) top.classList.toggle('is-scrolled', on);
    if (heroNav) heroNav.classList.toggle('gone', on);
  }
  window.addEventListener('scroll', sync, { passive: true });
  sync();

  /* ── menú lateral ───────────────────────────────────────────────── */
  var menu = document.getElementById('menu');
  var scrim = document.getElementById('scrim');
  var menuX = document.getElementById('menuX');
  var openers = document.querySelectorAll('[data-open]');
  var lastFocus = null;

  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('open', open);
    if (scrim) { scrim.classList.toggle('open', open); scrim.hidden = !open; }
    menu.setAttribute('aria-hidden', String(!open));
    openers.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { lastFocus = document.activeElement; if (menuX) menuX.focus(); }
    else if (lastFocus) { lastFocus.focus(); }
  }
  openers.forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  if (menuX) menuX.addEventListener('click', function () { setMenu(false); });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
  if (menu) menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('open')) setMenu(false);
  });

  /* ── tallas ─────────────────────────────────────────────────────── */
  var sizes = document.getElementById('sizes');
  if (sizes) {
    sizes.addEventListener('click', function (e) {
      var b = e.target.closest('.size');
      if (!b || b.disabled) return;
      this.querySelectorAll('.size').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      var id = b.getAttribute('data-variant');
      var input = document.getElementById('variantId');
      if (input && id) input.value = id;
      var atc = document.getElementById('atc');
      if (atc) { atc.disabled = false; atc.textContent = atc.getAttribute('data-label') || 'Add to cart'; }
    });
  }

  /* ── nombre del color, al pasar el cursor ───────────────────────── */
  var swName = document.getElementById('swName');
  var swBox = document.querySelector('.swatches');
  if (swName && swBox) {
    var cur = swBox.querySelector('.sw[aria-current]');
    function reset() { swName.textContent = cur ? (cur.dataset.name || '') : ''; }
    swBox.querySelectorAll('.sw').forEach(function (sw) {
      function on() { swName.textContent = sw.dataset.name || ''; swName.classList.add('on'); }
      sw.addEventListener('mouseenter', on);
      sw.addEventListener('focus', on);
    });
    swBox.addEventListener('mouseleave', function () { reset(); swName.classList.remove('on'); });
    swBox.addEventListener('focusout', function () { reset(); swName.classList.remove('on'); });
    reset();
  }

  /* ── móvil: puntos del carrusel ─────────────────────────────────── */
  var galEl = document.getElementById('gal');
  var galDots = document.querySelectorAll('#galDots i');
  if (galEl && galDots.length) {
    galEl.addEventListener('scroll', function () {
      var i = Math.round(galEl.scrollLeft / Math.max(1, galEl.clientWidth));
      galDots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }, { passive: true });
  }

  /* ── visor: se queda dentro de la columna del collage ───────────── */
  var shots = [].slice.call(document.querySelectorAll('.gcell img'));
  var lb = document.getElementById('lb');
  var lbImg = document.getElementById('lbImg');
  var lbNum = document.getElementById('lbNum');
  var at = 0;

  if (lb && lbImg && shots.length) {
    var wide = window.matchMedia('(min-width:981px)');

    function show(i) {
      at = (i + shots.length) % shots.length;
      lbImg.src = shots[at].currentSrc || shots[at].src;
      lbImg.alt = shots[at].alt;
      if (lbNum) lbNum.textContent = (at + 1) + ' / ' + shots.length;
    }
    /* la columna de las fotos tiene scroll propio: al abrir el visor se
       vuelve arriba y se congela, para que el collage no se mueva detrás */
    var galCol = document.querySelector('.gal-col');
    function openLb(i) {
      show(i);
      lb.hidden = false;
      if (galCol) { galCol.scrollTop = 0; galCol.classList.add('viendo'); }
    }
    function closeLb() {
      lb.hidden = true;
      if (galCol) galCol.classList.remove('viendo');
    }
    /* Rueda sobre la columna de las fotos.

       1. Con el visor abierto no hace nada: la foto ampliada no se va de la
          pantalla. Para seguir bajando, la rueda sobre la derecha o cerrar.
       2. Mientras queden fotos, movemos la galería nosotros, exactamente los
          píxeles del tic: un tic mueve la galería O la página, nunca las dos.
       3. Al llegar a la última foto nos comemos la cola del gesto durante un
          instante. Sin esto, la inercia que traía el trackpad se traspasa de
          golpe a la página y da un acelerón. Si sigues empujando de verdad,
          el tic siguiente ya pasa a la página, a su velocidad normal. */
    if (galCol) {
      var COLA = 260;      /* ms que absorbemos al llegar al final */
      var SEGUIDO = 80;    /* menos de esto entre tics = mismo gesto o inercia */
      var ultimoTic = 0, tocoFondo = 0;

      galCol.addEventListener('wheel', function (e) {
        if (galCol.classList.contains('viendo')) { e.preventDefault(); return; }
        if (!wide.matches) return;                 /* en móvil manda el carrusel */

        var ahora = e.timeStamp;
        var mismoGesto = (ahora - ultimoTic) < SEGUIDO;
        ultimoTic = ahora;

        var d = e.deltaY;
        if (e.deltaMode === 1) d *= 16;            /* el tic viene en líneas */
        else if (e.deltaMode === 2) d *= galCol.clientHeight;

        var tope = galCol.scrollHeight - galCol.clientHeight;
        if (tope <= 0) return;
        var at = galCol.scrollTop;

        if ((d > 0 && at < tope - 0.5) || (d < 0 && at > 0.5)) {
          tocoFondo = 0;
          e.preventDefault();
          galCol.scrollTop = Math.max(0, Math.min(tope, at + d));
          return;
        }

        if (!tocoFondo) tocoFondo = ahora;
        if (mismoGesto && (ahora - tocoFondo) < COLA) { e.preventDefault(); return; }
        /* a partir de aquí no tocamos nada: la página se desplaza sola */
      }, { passive: false });
    }

    document.querySelectorAll('.gcell').forEach(function (b) {
      /* en móvil manda el carrusel: un toque no debe abrir el visor */
      b.addEventListener('click', function () { if (wide.matches) openLb(+b.dataset.i); });
    });
    var prev = document.getElementById('lbPrev');
    var next = document.getElementById('lbNext');
    var x = document.getElementById('lbX');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(at - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(at + 1); });
    if (x) x.addEventListener('click', closeLb);
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') show(at - 1);
      if (e.key === 'ArrowRight') show(at + 1);
    });
  }
})();

/* === v23 · Políticas: párrafos limpios aunque el texto se haya pegado con saltos de línea ===
   Translate & Adapt guarda a veces un párrafo por bloque con <br> entre frases. Aquí cada
   tramo separado por <br> pasa a ser su propio <p>, para que todas las políticas tengan el
   mismo aire entre párrafos. Solo actúa dentro del cuerpo de las políticas. */
(function () {
  var body = document.querySelector('.shopify-policy__body .rte');
  if (!body) return;
  body.querySelectorAll('p').forEach(function (p) {
    if (!p.querySelector('br')) return;
    var parts = [[]];
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      if (n.nodeName === 'BR') parts.push([]); else parts[parts.length - 1].push(n);
    });
    parts = parts.filter(function (a) { return a.some(function (n) { return (n.textContent || '').trim(); }); });
    if (parts.length < 2) {
      p.querySelectorAll('br').forEach(function (b) { if (!b.nextSibling || !(b.nextSibling.textContent || '').trim()) b.remove(); });
      return;
    }
    var frag = document.createDocumentFragment();
    parts.forEach(function (a) { var np = document.createElement('p'); a.forEach(function (n) { np.appendChild(n); }); frag.appendChild(np); });
    p.replaceWith(frag);
  });
  /* saltos sueltos al principio o al final de un párrafo (p. ej. <br><strong>SECCIÓN 2…</strong>) */
  body.querySelectorAll('p br').forEach(function (b) {
    var p = b.closest('p');
    var r = document.createRange();
    r.setStart(p, 0); r.setEndBefore(b);
    var antes = r.toString().trim();
    r.setStartAfter(b); r.setEnd(p, p.childNodes.length);
    var despues = r.toString().trim();
    if (!antes || !despues) b.remove();
  });
})();
